module.exports = __webpack_public_path__ + "static/media/history.aa46198e.svg";